import React, { use, useEffect, useState } from "react";
// Components
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import SignupForm from "./pages/Auth/SignupForm";
import Onboarding from "./pages/OnBoarding/OnBoarding";
import VerifyEmail from "./pages/Auth/VerifyEmail";
import Confirmation from "./pages/Confirmation";
import AuthPage from "./pages/Auth/index";
import { useSelector } from "react-redux";
import LoginForm from "./pages/Auth/LoginForm";
import CookieBanner from "./pages/Home/CookieBanner";
// Assest
import AuthLeftImage from "./assets/images/auth-left-img.png";
import AuthImage from "./assets/images/auth-bg.svg";
import DashboardLayout from "./layout/index";
import Home from "./pages/Home/Home";
import Settings from "./pages/Settings/Settings";
import Shipments from "./pages/Shipments/Shipments";
import Shipments1 from "./pages/Shipments";
import OnboardingSteps from "./pages/OnBoarding/Steps/index";
import CreatePassword from "./pages/Auth/CreatePassword";
import PrivateRoutes from "./routes/PrivateRoutes";

import SettingsProfile from "./pages/Settings/SettingsProfile";
import SettingsNotification from "./pages/Settings/SettingsNotification";
import SettingsNotificationsForm from "./pages/Settings/SettingsNotificationsForm";
import SettingsTransportProvider from "./pages/Settings/SettingsTransportProvider";
import SettingsProduct from "./pages/Settings/SettingsProduct";
import SettingsSensor from "./pages/Settings/SettingsSensor";
import SettingsLocation from "./pages/Settings/SettingsLocation";
import SettingsUser from "./pages/Settings/SettingsUser";
import SettingsLocationForm from "./pages/Settings/SettingsLocationForm";
import SettingsProductForm from "./pages/Settings/SettingsProductForm";
import SettingsTransportForm from "./pages/Settings/SettingsTransportProviderForm";
import SettingsSensorForm from "./pages/Settings/SettingsSensorForm";
import SettingsUserForm from "./pages/Settings/SettingsUserForm";
import MapExternalView from "./pages/Shipments/MapExternalView";
// import AirportsHub from "./pages/Airports/AirportsHub";
import PrivateRestrictedRoutes from "./routes/AdminRoutes";
import LandingPage from "./pages/landing";
import TermsOfService from "./pages/termsofservice";
import PrivacyPolicy from "./pages/privacypolicy";
import { GoogleMapsProvider } from "./components/GoogleMapsProvider";
import { FullStory } from "@fullstory/browser";
import { useToken } from "./common/helper";
import CustomChatbot from "./components/CustomChatbot";
import Chatbot from "./pages/chatbot/Chatbot";
import { message } from "antd";
import { GetSettingsProfile } from "./api's/settings";
import SettingsTempNotificationsForm from "./pages/Settings/SettingsTempNotificationsForm";
import { RoleBaseRoutes } from "./routes/RoleBaseRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import EditorRestrictedRoutes from "./routes/EditorRestrictedRoutes";
import PublicRoutes from "./routes/PublicRoutes";
import ForgotPasswordRoutes from "./routes/ForgotPasswordRoutes";
import SettingsTeams from "./pages/Settings/SettingsTeams";
import SettingsLocations from "./pages/Settings/SettingsLocations";
import SettingsUserTable from "./pages/Settings/SettingsUserTable";
import TransportProviders from "./pages/Settings/TransportProviders";
import SettingsTeamBasedProfile from "./pages/Settings/SettingsTeamBasedProfile";
import SettingsProductTable from "./pages/Settings/SettingsProductTable";
import CreateAccount from "./pages/OnBoarding/Steps/CreateAccount";
import SettingsSensorTable from "./pages/Settings/SettingsSensorTable";
import RolesAndPermissions from "./pages/Settings/RolesAndPermissions";
import Sensors from "./pages/Settings/Sensors";
//import SettingsLocations from "./pages/Settings/Locations";
import NotificationList from "./pages/Settings/NotificationList";
import NotificationSetup from "./pages/OnBoarding/Steps/NotificationsSetup";
import AirlineList from "./pages/airlines/AirlineList";
import CustomsContact from "./pages/Airports/components/CustomsContact";
import CustomsOffice from "./pages/Airports/components/CustomsOffice";
import AirportList from "./pages/Airports/components/AirportList";
import AirlineDetail from "./pages/airline-detail/page";
import AirportsHub from "./pages/Airports/components/AirportsHub";
import CompanyContacts from "./pages/company-contacts/page";
import AIworkflow from "./pages/Settings/AIworkflow";
import AlertThresholds from "./pages/Settings/AlertThresholds/AlertThresholds";
import CompanyInfo from "./pages/Settings/CompanyInfo/CompanyInfo";
import { GoogleMap } from "@react-google-maps/api";

const App = () => {
  const { token, userID, removeToken, decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [userData, setUserData] = useState({});

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
    }
  };

  useEffect(() => {
    if (token) {
      fetchProfile();
    }
    // FullStory Variables
    // window["_fs_host"] = "fullstory.com";
    // window["_fs_script"] = "edge.fullstory.com/s/fs.js";
    // window["_fs_org"] = "o-22MP9G-na1";
    // window["_fs_namespace"] = "FS";

    // // Create and Inject the FullStory script
    // const script = document.createElement("script");
    // script.async = true;
    // script.crossOrigin = "anonymous";
    // script.src = "https://edge.fullstory.com/s/fs.js";
    // script.onload = () => {
    //   console.log(FullStory)
    //   console.log("FullStory script loaded");
    // };
    // script.onerror = () => {
    //   console.error("Failed to load FullStory script");
    // };

    // document.head.appendChild(script);
  }, [token]);

  const fetchProfile = () => {
    GetSettingsProfile(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              setUserData(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      });
  };

  useEffect(() => {
    if (FullStory && userData) {
      FullStory("setProperties", {
        type: "user",
        properties: {
          displayName: userData && userData?.name,
          email: userData && userData?.email,
        },
      });
    }
  }, [FullStory, userData]);

  useEffect(() => {
    if (token && FullStory) {
      FullStory("setIdentity", {
        uid: userID,
        properties: {
          displayName: userData && userData?.name,
          email: userData && userData?.email,
        },
      });
    }
  }, [token, userID]);

  return (
    <>
      <CookieBanner></CookieBanner>
      <section className="main-container">
        {/* {isAuthenticated &&
          decodedToken?.company_name.toLowerCase() != "zoomlogi" && (
            <CustomChatbot />
          )} */}
        <BrowserRouter>
          <GoogleMapsProvider>
          <Routes>
            {/* guest routes  */}

           

            <Route element={<PublicRoutes />}>
            <Route path="/" index element={<LandingPage />} />
            <Route
              path="/terms-of-service"
              index
              element={<TermsOfService />}
            />
            <Route path="/privacy-policy" index element={<PrivacyPolicy />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route
              path="/verify-email"
              element={
                <Onboarding>
                  <VerifyEmail />
                </Onboarding>
              }
            />
              <Route
                path="/signup"
                element={
                  <AuthPage
                    title="You’re on your way to protecting all your critical shipments."
                    description="Start setting up your ZoomLogi account and you’ll be one step closer to preventing waste, reducing inefficiencies, and improving patient outcomes."
                    imageSrc={AuthImage}
                    imageOnLeft={false}
                    pageName="Signup"
                  >
                    <SignupForm />
                  </AuthPage>
                }
              />

              <Route
                path="/login"
                element={
                  <AuthPage
                    title="You’re on your way to protecting all your critical shipments."
                    description="Start setting up your ZoomLogi account and you’ll be one step closer to preventing waste, reducing inefficiencies, and improving patient outcomes."
                    imageSrc={AuthImage}
                    imageOnLeft={false}
                    pageName="Login"
                  >
                    <LoginForm />
                  </AuthPage>
                }
              />
            </Route>
          
            <Route path="/forgot-password" element={<ForgotPasswordRoutes />} />
            <Route
              path="/create-password"
              element={
                <Onboarding>
                  <CreatePassword />
                </Onboarding>
              }
            />

            <Route
              path="/confirmation"
              element={
                <Onboarding>
                  <Confirmation />
                </Onboarding>
              }
            />
            {/* authenticated routes  guard applied  */}
            
            <Route element={<PrivateRoutes />}>


            <Route
                path="/airport-list"
                element={
                  <DashboardLayout>
                    <AirportList />
                  </DashboardLayout>
                }
              />
              <Route
                path="/airport/:code"
                element={
                  <DashboardLayout>
                    <AirlineList setAirportName={(name) => <CustomsContact airportName={name} />} />
                  </DashboardLayout>
                }
              />
              <Route
                path="/airline-detail/:airlineName"
                element={
                  <DashboardLayout>
                    <AirlineDetail />
                  </DashboardLayout>
                }
              />
              <Route
                path="/contact/:airlineName/company-contact"
                element={
                  <DashboardLayout>
                    <CompanyContacts />
                  </DashboardLayout>
                }
              />
              <Route
                path="/airport/:code/customs"
                element={
                  <DashboardLayout>
                    <CustomsOffice />
                  </DashboardLayout>
                }
              />


    
              {/* //wills show to all */}
              <Route
                path="/dashboard"
                element={
                  <DashboardLayout>
                    <Home />
                  </DashboardLayout>
                }
              />
              <Route
                path="/settings"
                element={<Navigate to="/settings/profile" replace />}
              />

              <Route
                path="/settings/profile"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsTeamBasedProfile title="My profile" />
                      {/* <SettingsProfile title="My profile" /> */}
                      {/* <SettingsTeamBasedProfile title="My profile" /> */}
                    </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/updated-profile"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsTeamBasedProfile title="My profile" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/shipment/external-view/:id"
                element={<MapExternalView />}
              />
              <Route
                path="/shipment"
                element={
                  <DashboardLayout>
                    <Shipments />
                  </DashboardLayout>
                }
              />
                 <Route
                path="/settings/aiworkflow"
                element={
                  <DashboardLayout>
                    <Settings>
                    <AIworkflow title='AI workflow' />
                  </Settings>
                  </DashboardLayout>
                }
              />

                 <Route
                path="/settings/company-info"
                element={
                  <DashboardLayout>
                    <Settings>
                    <CompanyInfo title='Company info' />
                  </Settings>
                  </DashboardLayout>
                }
              />
                  <Route
                path="/settings/threshold"
                element={
                  <DashboardLayout>
                    <Settings>
                    <AlertThresholds title='Alert thresholds' />
                  </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/notificationlist"
                element={
                  <DashboardLayout>
                    <Settings>
                      <NotificationList title="Notifications" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}

              <Route
                path="/settings/notification"
                element={
                  <DashboardLayout>
                    <Settings>
                    <NotificationList title="Notifications" />
                      {/* <SettingsNotification title="Notifications" /> */}
                    </Settings>
                  </DashboardLayout>
                }
              />
              <Route
                path="/create-account"
                element={
                  <Onboarding>
                    <CreateAccount />
                  </Onboarding>
                }
              />
              {/* <Route
                path="/onboarding-notification"
                element={

                  <NotificationSetup />

                }
              /> */}

              {/* {admin routes or editor routes} */}
              {/* <Route element={<AdminRoutes />}> */}
              {/* <Route element={<EditorRestrictedRoutes />}> */}
              <Route
                path="/onboarding"
                element={
                  <Onboarding>
                    <OnboardingSteps />
                  </Onboarding>
                }
              />
              {/* </Route> */}
              {/* <Route element={<EditorRestrictedRoutes />}>

              </Route> */}
              <Route path="/confirmation" element={<Confirmation />} />
              {/* <Route
              path="/settings"
              element={
                <DashboardLayout>
                  <Settings />
                </DashboardLayout>
              }
            /> */}


{/*             
              <Route
                path="/settings/temp-notification"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsTempNotificationsForm title="Notifications" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/settings/notification/form"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsNotificationsForm />
                    </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/user-list"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsUserTable title="Users" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              {/* <Route
                path="/settings/notification/form/:id"
                element={
                  <DashboardLayout>
                    <Settings
                      isUpdateForm={true}
                      backUrl="/settings/notification"
                    >
                      <SettingsNotificationsForm />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/settings/roles"
                element={
                  <DashboardLayout>
                    <Settings>
                      <RolesAndPermissions title="Roles" />
                    </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/updated-couriers"
                element={
                  <DashboardLayout>
                    <Settings>
                      <TransportProviders title="Transport Providers" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/settings/couriers"
                element={
                  <DashboardLayout>
                    <Settings>
                      <TransportProviders title="Transport Providers" />
                      {/* <SettingsTransportProvider title="Transport Provider" /> */}
                    </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/couriers/form"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsTransportForm />
                    </Settings>
                  </DashboardLayout>
                }
              />
              <Route
                path="/settings/couriers/form/:id"
                element={
                  <DashboardLayout>
                    <Settings
                      isUpdateForm={true}
                      backUrl="/settings/couriers"
                    >
                      <SettingsTransportForm />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}

              <Route
                path="/settings/team"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsTeams title="Teams" />
                    </Settings>
                  </DashboardLayout>
                }
              />

              <Route
                path="/settings/product"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsProductTable title="Products" />
                      {/* <SettingsProduct title="Products" /> */}
                    </Settings>
                  </DashboardLayout>
                }
              />

              {/* <Route
                path="/settings/product-list"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsProductTable title="Products" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              {/* <Route
                path="/settings/product/form"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsProductForm />
                    </Settings>
                  </DashboardLayout>
                }
              />
              <Route
                path="/settings/product/form/:id"
                element={
                  <DashboardLayout>
                    <Settings isUpdateForm={true} backUrl="/settings/product">
                      <SettingsProductForm />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/settings/sensor"
                element={
                  <DashboardLayout>
                    <Settings>
                      <Sensors title="Sensors" />
                      {/* <SettingsSensor title="Sensors" /> */}
                    </Settings>
                  </DashboardLayout>
                }
              />
              {/* <Route
                path="/settings/sensor-list"
                element={
                  <DashboardLayout>
                    <Settings>
                      <Sensors title="Sensors" />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              {/* <Route
                  path="/settings/sensor-list"
                  element={
                    <DashboardLayout>
                      <Settings>
                        <SettingsSensorTable title="Sensors" />
                      </Settings>

                    </DashboardLayout>
                  }
                /> */}
              {/* <Route
                path="/settings/sensor/form"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsSensorForm />
                    </Settings>
                  </DashboardLayout>
                }
              />
              <Route
                path="/settings/sensor/form/:id"
                element={
                  <DashboardLayout>
                    <Settings isUpdateForm={true} backUrl="/settings/sensor">
                      <SettingsSensorForm />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route
                path="/settings/location"
                element={
                  <DashboardLayout>
                    <Settings>
                      <SettingsLocations title="Locations" />
                      {/* <SettingsLocation title="Locations" />  */}
                     </Settings>
                  </DashboardLayout>
                }
              />   
              {/* <Route
                path="/settings/updated-location"
                element={
                  <DashboardLayout>
                    <Settings> */}
                      {/* <SettingsLocations title="Locations" /> */}
                    {/* </Settings>
                  </DashboardLayout>
              }
              /> */}
              {/* <Route
                path="/settings/location/form"
                element={
                  <DashboardLayout>
                    <Settings>
                      <GoogleMapsProvider>
                        <SettingsLocationForm title="New Location" />
                      </GoogleMapsProvider>
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              {/* <Route
                path="/settings/location/form/:id"
                element={
                  <DashboardLayout>
                    <Settings
                      isUpdateForm={true}
                      backUrl="/settings/location"
                    >
                      <SettingsLocationForm />
                    </Settings>
                  </DashboardLayout>
                }
              /> */}
              <Route element={<EditorRestrictedRoutes />}>
                <Route
                  path="/settings/user"
                  element={
                    <DashboardLayout>
                      <Settings>
                        <SettingsUserTable title="Users" />
                        {/* <SettingsUser title="Users" /> */}
                      </Settings>
                    </DashboardLayout>
                  }
                />
                {/* <Route
                  path="/settings/user/form"
                  element={
                    <DashboardLayout>
                      <Settings>
                        <SettingsUserForm title="New User" />
                      </Settings>
                    </DashboardLayout>
                  }
                /> */}
                {/* <Route
                  path="/settings/user/form/:id"
                  element={
                    <DashboardLayout>
                      <Settings isUpdateForm={true} backUrl="/settings/user">
                        <SettingsUserForm />
                      </Settings>
                    </DashboardLayout>
                  }
                /> */}
              </Route>

              {/* <Route
              path="/chatbot"
              element={
                <DashboardLayout>
                  <Chatbot />
                </DashboardLayout>
              }
            /> */}
              <Route
                path="/chatbot"
                element={
                  <DashboardLayout>
                    <Chatbot />
                  </DashboardLayout>
                }
              />

              <Route
                path="/shipment1"
                element={
                  // <DashboardLayout>
                  <Shipments1 />
                  // </DashboardLayout>
                }
              />
              {/* {decodedToken?.role?.toLowerCase() ===  'admin' &&
           <Route element={<RoleBaseRoutes allowedRoles={['admin']} decodedToken={decodedToken} />}> */}

              {/* </Route>
            } */}
              {/* <Route
                path="/airports-hub"
                element={
                  <DashboardLayout>
                    <AirportsHub />
                  </DashboardLayout>
                }
              /> */}
              {/* </Route> */}
            </Route>
            <Route
              path="/share/shipment/external-view/:id/:uuid"
              element={<MapExternalView />}
            />

            {/* Default route */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          </GoogleMapsProvider>
        </BrowserRouter>
      </section>
    </>
  );
};

export default App;
